// Presentation only: counts still come from the authorized dashboard aggregate.
export const populationColors = { low: "#eef8f1", middle: "#77b58e", high: "#124b36", missing: "#e8ece9" };

export function formatMapCount(value: number | null | undefined) {
  return typeof value === "number" && Number.isFinite(value) && value >= 0
    ? value.toLocaleString()
    : "Unavailable";
}

export function createPopulationScale(values: readonly (number | null | undefined)[]) {
  const valid = values.filter((value): value is number =>
    typeof value === "number" && Number.isFinite(value) && value >= 0,
  );
  const minimum = valid.length ? Math.min(...valid) : 0;
  const maximum = valid.length ? Math.max(...valid) : 0;
  return (population: number | null | undefined) => {
    if (typeof population !== "number" || !Number.isFinite(population) || population < 0) {
      return { fill: populationColors.missing, dark: false, missing: true };
    }
    // Equal positive counts use the midpoint; no records use the pale endpoint.
    const ratio = maximum === minimum
      ? (population > 0 ? 0.5 : 0)
      : Math.max(0, Math.min(1, (population - minimum) / (maximum - minimum)));
    const start = ratio <= 0.5 ? populationColors.low : populationColors.middle;
    const end = ratio <= 0.5 ? populationColors.middle : populationColors.high;
    const fraction = ratio <= 0.5 ? ratio * 2 : (ratio - 0.5) * 2;
    const channels = [1, 3, 5].map((offset) => Math.round(
      parseInt(start.slice(offset, offset + 2), 16) * (1 - fraction) +
      parseInt(end.slice(offset, offset + 2), 16) * fraction,
    ));
    return { fill: `#${channels.map((value) => value.toString(16).padStart(2, "0")).join("")}`, dark: ratio >= 0.65, missing: false };
  };
}
